import {
  RadioGroupButton,
  type RadioGroupButtonConfig,
} from '@carboncopyco/ui';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage, FormField } from './FormField';
import { responseRepresentationTypeSchema } from './schema';

type ResponseRepresentationType = 'raw' | 'form';

const fieldName = 'representationType';
const fieldLabel = responseRepresentationTypeSchema.describe().label;

const buttonsConfig: RadioGroupButtonConfig<ResponseRepresentationType>[] = [
  {
    id: 'form',
    label: 'Form',
  },
  {
    id: 'raw',
    label: 'Raw JSON',
  },
];

export interface ResponseRepresentationTypeProps {
  hideLabel?: boolean;
}

export const ResponseRepresentationType = ({
  hideLabel,
}: ResponseRepresentationTypeProps) => {
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const responseType = watch(fieldName);

  useEffect(() => {
    register(fieldName);
  }, []);

  return (
    <FormField
      name={fieldName}
      label={!hideLabel && fieldLabel}
    >
      <div className="self-start">
        <RadioGroupButton
          buttonsConfig={buttonsConfig}
          onClick={(type) => setValue(fieldName, type, { shouldDirty: true })}
          selected={responseType}
        />
      </div>
      <ErrorMessage errors={errors} />
    </FormField>
  );
};
